var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShow
    ? _c(
        "div",
        {
          staticClass: "header-notification notification-container-header",
          class: "hn-" + _vm.notification_type,
          attrs: { id: "notification-container" },
        },
        [
          _c(
            "div",
            { staticClass: "header-notification__content" },
            [
              _c("app-shell-icon", {
                staticClass: "header-notification__icon",
                attrs: { name: _vm.icon, size: 16 },
              }),
              _c(
                "div",
                {
                  ref: "body",
                  staticClass: "header-notification__body",
                  class: { "is-clamped": !_vm.expanded },
                  attrs: { id: _vm.bodyId },
                },
                [
                  _vm._v("\n      " + _vm._s(_vm.firstDiagnosis) + "\n      "),
                  _vm.secondDiagnosis
                    ? [
                        _c("br"),
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.secondDiagnosis) +
                            "\n      "
                        ),
                      ]
                    : _vm._e(),
                  _vm.link && _vm.link.learn_more_href
                    ? _c(
                        "a",
                        {
                          staticClass: "header-notification__link",
                          attrs: {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            "data-testid":
                              "header-notification-learn-more-link",
                            href: _vm.link.learn_more_href,
                          },
                          on: { click: _vm.openLearnMoreLink },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.link.learn_more_title ?? "Learn more")
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm.overflows || _vm.expanded
                ? _c(
                    "button",
                    {
                      staticClass: "header-notification__more",
                      attrs: {
                        type: "button",
                        "data-testid": "header-notification-more-btn",
                        "aria-controls": _vm.bodyId,
                        "aria-expanded": String(_vm.expanded),
                      },
                      on: {
                        click: function ($event) {
                          _vm.expanded = !_vm.expanded
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.expanded ? "Less" : "More") +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.link && _vm.staticsLoaded && !_vm.statics.whitelabel
            ? _c("div", { staticClass: "header-notification__actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "header-notification__action",
                    attrs: {
                      type: "button",
                      "data-testid": "header-notification-action-btn",
                    },
                    on: { click: _vm.openDiagnosisLink },
                  },
                  [_vm._v("\n      " + _vm._s(_vm.link.title) + "\n    ")]
                ),
              ])
            : _vm._e(),
          _vm.staticsLoaded && !_vm.statics.whitelabel
            ? _c(
                "button",
                {
                  staticClass: "header-notification__close",
                  attrs: {
                    type: "button",
                    "aria-label": "Dismiss",
                    "data-testid": "header-notification-close-btn",
                  },
                  on: { click: _vm.close },
                },
                [_c("app-shell-icon", { attrs: { name: "x", size: 16 } })],
                1
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }